module.exports = __webpack_public_path__ + "static/img/2.3baf8949.png";